<template>
  <div>
    <div class="business-info-view">
      <el-form
        label-width="190px"
        :model="queryParams"
        :rules="rules"
        ref="basicInformationRule"
      >
        <p class="info-title">联系信息与公开信息</p>

        <div class="business-info-block">
          <el-form-item label="资讯标题：" prop="title">
            <el-input
              v-model="queryParams.title"
              style="width: 867px;"
            ></el-input>
          </el-form-item>

          <el-form-item label="资讯类别：" prop="infoCategory">
            <SelectTreeRadio
              apiName="getDicRadioButton"
              :params="{ code: '054' }"
              resultType="values"
              vFeild="codeId"
              lFeild="codeName"
              storageKey="infoCategoryList"
              :isCheckBoxButton="false"
              v-model="queryParams.infoCategory"
            ></SelectTreeRadio>
          </el-form-item>

          <el-form-item label="资讯类型：" prop="informationType">
            <SelectTreeRadio
              apiName="getDicRadioButton"
              :params="{ code: '023' }"
              resultType="values"
              vFeild="codeId"
              lFeild="codeName"
              storageKey="informationTypeList"
              :isCheckBoxButton="false"
              v-model="queryParams.informationType"
            ></SelectTreeRadio>
          </el-form-item>

          <el-form-item label="资讯链接:" prop="website">
            <el-link
              :href="queryParams.titleLink"
              target="_blank"
              :underline="false"
              >{{ queryParams.titleLink }}</el-link
            >

            <span class="edit-link-btn">
              <i
                class="jr-iconjr-icon-edit1"
                style="margin-left: 24px;"
                @click="isLinkShow = true"
              ></i>
            </span>

            <div class="input_button" v-if="isLinkShow">
              <el-input v-model="queryParams.titleLink" style="width: 470px" />
              <el-button
                type="primary"
                style="height: 40px; margin-left: 24px"
                @click="isLinkShow = false"
                >保存</el-button
              >
            </div>
          </el-form-item>

          <el-form-item label="资讯来源：" prop="origin">
            <el-input
              style="width: 867px;"
              v-model="queryParams.origin"
            ></el-input>
          </el-form-item>

          <el-form-item label="资讯作者：" prop="author">
            <el-input
              style="width: 867px;"
              v-model="queryParams.author"
            ></el-input>
          </el-form-item>

          <el-form-item label="资讯描述：" prop="introduction">
            <Editorbar v-model="queryParams.introduction" />
          </el-form-item>

          <div class="attr-info">
            <el-form-item label="资讯附件：" label-width="100px">
              <div class="operate-group">
                <UploadFile
                  :buttonText="'上传附件'"
                  @success="uploadFactoryDoc"
                />

                <div class="delete-box">
                  <el-button
                    plain
                    size="small"
                    icon="el-icon-delete"
                    @click="handleDeletes"
                    >批量删除</el-button
                  >
                </div>
              </div>
            </el-form-item>

            <div class="attr-table-box">
              <el-table
                :data="newsFileList"
                style="width: 870px"
                @selection-change="newFilesChange"
              >
                <el-table-column type="selection" width="105">
                </el-table-column>

                <el-table-column
                  label="附件名称"
                  prop="newsFileName"
                  width="500"
                ></el-table-column>

                <el-table-column label="操作" align="center">
                  <template slot-scope="{ row }">
                    <button-table
                      content="下载"
                      icon="jr-iconjr-icon-download"
                      @buttonClick="downloadFactoryDoc(row)"
                    />
                    <button-table
                      content="查看"
                      icon="jr-iconjr-icon-eye"
                      @buttonClick="handleView(row)"
                    />
                    <button-table
                      content="编辑"
                      icon="jr-iconjr-icon-edit"
                      @buttonClick="handleEdit(row)"
                    />
                    <button-table
                      content="删除"
                      icon="jr-iconjr-icon-delect"
                      :iconClolor="'#f56c6c'"
                      @buttonClick="handleDelete(row)"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <el-form-item label="资讯图片：" prop="imgLinkList">
            <MyImageUpload
              :upLoadImgList.sync="queryParams.imgLinkList"
              :limitCount="5"
              @upLoadImgList="e => onChangeUpLoadImgList('imgLinkList', e)"
            />
          </el-form-item>

          <el-form-item label="封面图片：" prop="coverImageList">
            <MyImageUpload
              :upLoadImgList.sync="queryParams.coverImageList"
              :limitCount="1"
              @upLoadImgList="e => onChangeUpLoadImgList('coverImageList', e)"
            />
          </el-form-item>

          <el-form-item label="分享图片：" prop="shareImage">
            <MyImageUpload
              :upLoadImgList.sync="queryParams.shareImage"
              :limitCount="1"
              @upLoadImgList="e => onChangeUpLoadImgList('shareImage', e)"
            />
          </el-form-item>

          <el-form-item label="一句话介绍：" prop="informationBrief">
            <el-input
              v-model="queryParams.informationBrief"
              style="width: 867px;"
            ></el-input>
          </el-form-item>

          <el-form-item label="发布时间：" prop="articleReleaseDate">
            <!-- <el-input
              v-model="queryParams.articleReleaseDate"
              style="width: 867px;"
            ></el-input> -->

            <el-date-picker
              v-model="queryParams.articleReleaseDate"
              type="datetime"
            >
            </el-date-picker>
          </el-form-item>
        </div>

        <div class="business-info-block" prop="newsLabelList">
          <el-form-item label="赋能行业：" label-width="190px">
            <SelectTreeRadio
              :isTree="true"
              apiName="getIndustryList"
              :params="{
                groupLabelType: '赋能行业标签组',
                level: 4
              }"
              resultType="values"
              storageKey="industryCategoryList"
              v-model="queryParams.newsLabelList"
              :isRadioFirstLevel="false"
              :isCheckBoxButton="false"
            ></SelectTreeRadio>
          </el-form-item>
        </div>

        <p class="info-title">爬虫信息</p>

        <div class="business-info-block">
          <el-form-item label="爬虫编号：">
            <span>{{ queryParams.crawlerNumber }}</span>
          </el-form-item>

          <el-form-item label="爬虫名称：" prop="crawlerName">
            <el-input
              style="width: 867px;"
              v-model="queryParams.crawlerName"
            ></el-input>
          </el-form-item>

          <el-form-item label="爬取网站：" prop="crawlWebsite">
            <el-input
              style="width: 867px;"
              v-model="queryParams.crawlWebsite"
            ></el-input>
          </el-form-item>

          <el-form-item label="爬取时间：" prop="crawlTime">
            <el-input
              style="width: 867px;"
              v-model="queryParams.crawlTime"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <FileUploadPopup
      ref="fileUploadPopup"
      :show="popupShow"
      @close="popupShow = false"
      @uploadSuccess="handleUploadSuccess"
    />
  </div>
</template>

<script>
import UploadImage from "@/components/UploadImage.vue";
import { editNew, getNewsInfo, getAllCompanyList } from "@/api/news.js";
import DicCheckboxGroup from "@/components/DicCheckboxGroup.vue";
import { getDicRadioButton } from "@/api/common";
import cos from "../../../../utils/cos.js";

// utils
import { downFile } from "@/utils/tool";
// api
import {
  getNewsBasicInfo,
  updateNewsBasicInfo,
  insertNewsFile,
  getNewsFile,
  updateNewsFile,
  deleteNewsFile
} from "@/api/news.js";
// components
import Editorbar from "@/components/Editorbar.vue";
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";
import MyImageUpload from "@/components/MyImageUpload/index.vue";
import UploadFile from "@/components/UploadFile.vue";
import ButtonTable from "@/components/ButtonTable.vue";
import FileUploadPopup from "@/components/FileUploadPopup/index.vue";

export default {
  name: "BasicInformation",
  components: {
    DicCheckboxGroup,
    Editorbar,
    UploadImage,
    SelectTreeRadio,
    MyImageUpload,
    UploadFile,
    ButtonTable,
    FileUploadPopup
  },
  props: {
    queryParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    newsDataId() {
      return this.$route.query.newsData;
    },
    personType() {
      return Number(this.$route.query.personType);
    },
    newsEdit() {
      return Number(this.$route.query.newsEdit);
    }
  },
  data() {
    return {
      productFileList: [""],
      loadingKeyword: false,
      options: [], //数智企业
      isShow: false,
      isLinkShow: false,
      data: "",
      newsFileList: [],
      newFilesChooseList: [],
      queryInfo: {
        positionType: ""
      },
      rules: {
        title: [{ required: true, message: "请输入资讯标题", trigger: "blur" }]
      },
      docList: [],
      isInit: false,
      popupShow: false,
      editId: ""
    };
  },
  created() {
    // this.getDicRadioButtons();
    // this.getAllCompanyList();
    this.getNewsFileAPI();

    if (this.personType) {
      // this.viewDetails();

      setTimeout(() => {
        this.isShow = true;
      }, 500);
    } else {
      this.isShow = true;
    }
  },
  methods: {
    newFilesChange(e) {
      this.newFilesChooseList = e;
    },
    onChangeUpLoadImgList(fieldName, val) {
      this.queryParams[fieldName] = val.map(item => item.url);
    },
    getInfo() {
      if (this.isInit) {
        return;
      }

      getNewsBasicInfo({ id: this.$route.query.newsData }).then(res => {
        if (res.code == 200) {
          this.isInit = true;
          for (let key in res.data) {
            if (
              [
                "newsFileList",
                "imgLinkList",
                "coverImageList",
                "newsLabelList"
              ].includes(key)
            ) {
              if (Array.isArray(res.data[key]) && res.data[key].length) {
                this.$set(this.queryParams, key, res.data[key]);
              } else {
                this.$set(this.queryParams, key, []);
              }
            } else if (key === "shareImage") {
              if (res.data[key]) {
                this.$set(this.queryParams, key, [res.data[key]]);
              }
            } else {
              this.$set(this.queryParams, key, res.data[key]);
            }
          }
        }
      });
    },
    getNewsFileAPI() {
      getNewsFile({ id: this.$route.query.newsData }).then(res => {
        if (res.code == 200 && Array.isArray(res.data)) {
          this.newsFileList = res.data;
        }
      });
    },
    downloadFactoryDoc(row) {
      downFile(
        { urlStr: this.getSeverFileUrl(row.newsFileKey) }, // 后台需要的参数
        "/public/downloadUrlFile", // 路径
        row.newsType, // 下载的文件类型
        row.newsFileName //下载文件名称
      );
    },
    handleDelete(row) {
      this.$confirm("确认删除此条附件吗 ?", "提示")
        .then(async () => {
          this.deleteNewsFileAPI([row.id]);
        })
        .catch(() => {});
    },
    handleDeletes() {
      if (!this.newFilesChooseList.length) {
        this.$message.warning("请选择需要批量删除的数据！");
        return;
      }

      this.$confirm("确认删除所选附件吗 ?", "提示").then(async () => {
        this.deleteNewsFileAPI(
          this.newFilesChooseList.map(item => {
            return item.id;
          })
        );
      });
    },
    deleteNewsFileAPI(params) {
      deleteNewsFile(params).then(res => {
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.getNewsFileAPI();
        }
      });
    },
    handleUploadSuccess(e) {
      const index = this.newsFileList.findIndex(item => {
        return item.id === this.editId;
      });

      this.popupShow = false;
      if (index === -1) {
        this.$message.error("修改失败");
      } else {
        this.newsFileList[index].newsType = e.type;
        this.newsFileList[index].newsFileName = e.name;
        this.newsFileList[index].newsFileKey = e.url;
        this.$refs.fileUploadPopup?.clear();
        this.updateNewsFileAPI(this.newsFileList[index]);
      }
    },
    handleEdit(row) {
      this.editId = row.id;
      this.popupShow = true;
    },
    uploadFactoryDoc(e) {
      this.insertNewsFileAPI({
        newsFileIntro: "",
        newsFileKey: e.url,
        newsFileName: e.name,
        newsId: this.$route.query.newsData,
        newsType: e.type
      });
    },
    handleView(row) {
      window.open(this.getSeverFileUrl(row.newsFileKey));
    },
    insertNewsFileAPI(params) {
      insertNewsFile(params).then(res => {
        if (res.code === 200) {
          this.$message.success("新增成功");
          this.getNewsFileAPI();
        }
      });
    },
    updateNewsFileAPI(params) {
      updateNewsFile(params).then(res => {
        if (res.code === 200) {
          this.$message.success("编辑成功");
          this.getNewsFileAPI();
        }
      });
    },
    submit() {
      this.$modal.loading("正在保存数据，请稍候...");

      let params = { ...this.queryParams };

      if (Array.isArray(params.shareImage) && params.shareImage.length) {
        params.shareImage = params.shareImage[0];
      } else {
        params.shareImage = "";
      }

      updateNewsBasicInfo(params)
        .then(res => {
          if (res.code === 200) {
            this.$message.success("编辑成功");
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.$modal.closeLoading();
        });
    },
    // 查询所有的企业
    async getAllCompanyList() {
      const res = await getAllCompanyList({ companyName: "" });
      if (res.code === 200) {
        this.options = res.data;
      }
    },
    // 远程查询
    async remoteMethod(query) {
      if (query !== "") {
        this.loadingKeyword = true;
        const res = await getAllCompanyList({ companyName: query });
        if (res.code === 200) {
          this.loadingKeyword = false;
          this.options = res.data;
        }
      } else {
        this.options = [];
      }
    },
    //上传行业动态pdf (上传文件之前的钩子，参数为上传的文件)
    async beforeUploadprods(file) {
      this.file = file;
      this.filename = file.name;
      // 要求上传格式
      let format = file.name.split(".")[1];

      let formatList = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf"];

      const extension = formatList.indexOf(format);
      if (extension == -1) {
        this.$message.warning("上传模板不支持此格式");
        return;
      }
      // 异步读取文件机制
      let reader = new FileReader();
      // 读取文件内容，结果用data:url的字符串形式表示
      reader.readAsDataURL(file);

      let that = this;
      // readAsDataURL 方法会读取指定的 Blob 或 File 对象，并生成data URl(base64编码)
      reader.onload = function() {
        that.fileData = reader.result;
      };
      return false;
    },
    //上传行业动态
    uploadprods(params, index) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      /* 直接调用 cos sdk 的方法 */
      cos
        .uploadFile({
          Bucket: "ginseng-wisdom-1300257084" /* 填写自己的 bucket，必须字段 */,
          Region: "ap-nanjing" /* 存储桶所在地域，必须字段 */,
          Key:
            "system_img/" +
            params.file
              .name /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
          Body: params.file, // 上传文件对象
          SliceSize:
            1024 *
            1024 *
            500 /* 触发分块上传的阈值，超过5MB 使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */
        })
        .then(res => {
          if (res.statusCode === 200) {
            // this.detailedInfo.productFileList[index].name = res.Location;
            // vue2无法监控数组的改变
            this.$set(this.newsData.productFileList, index, res.Location);
            loading.close();
          }
        })
        .catch(err => {
          loading.close();
          console.log("上传出错", err);
        });
    },

    //新增行业动态附件
    addUpload() {
      this.newsData.productFileList.push("");
    },
    //删除行业动态附件
    delUpload(index) {
      this.newsData.productFileList.splice(index, 1);
    },
    lookClickTemp(val) {
      this.newsData.imgLink = val;
    },
    saveClickTemp(val) {
      this.newsData.coverImage = val;
    },
    onChange() {},
    cancelItem() {
      this.$router.go(-1);
    },
    // 资讯查询
    async viewDetails() {
      const res = await getNewsInfo({ id: this.newsDataId });
      if (res.code == 200) {
        this.newsData = res.data;

        if (this.newsData.informationType) {
          this.newsData.informationTypes = this.newsData.informationType.split(
            ","
          );
        } else {
          this.newsData.informationTypes = [];
        }
        if (!this.newsData.productFileList) {
          this.newsData.productFileList = [""];
        }

        // 关联企业回显
        if (res.data.associatedCompanyId) {
          this.options = [
            {
              companyFullName: res.data.companyName,
              id: res.data.associatedCompanyId
            }
          ];
        }
        // 案例图片
        if (res.data.coverImage == '["[]"]' || res.data.imgLink == '["[]"]') {
          this.newsData.coverImage = "";
        }
        // 资讯封面图
        if (
          res.data.shareImage == '["[]"]' ||
          res.data.shareImageLink == '["[]"]'
        ) {
          this.newsData.shareImage = "";
        }
      } else {
        this.$message.error("查询失败");
      }
    }
    // async editType() {
    //   this.newsData.informationType = this.newsData.informationTypes.join(",");
    //   const res = await editNew(this.newsData);
    //   if (res.code == 200) {
    //     this.$message.success("修改成功");
    //     this.$router.go(-1);
    //   } else {
    //     this.$message.success("修改失败");
    //   }
    // },
  }
};
</script>

<style scoped lang="less">
.attr-info {
  margin-left: 90px;
  margin-bottom: 40px;
}

.business-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .business-info-block {
    border-bottom: 20px solid #d8efff;

    &:last-child {
      border-bottom: 0;
    }

    .table-box {
      margin-top: 10px;
      padding-left: 190px;
      padding-bottom: 10px;

      .table-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-size: 16px;
        color: #333333;

        &::before {
          content: "";
          display: block;
          margin-right: 4px;
          width: 7px;
          height: 7px;
          background-color: #1e9fff;
          border-radius: 50%;
        }
      }
    }
  }

  .tag {
    margin-left: 8px;
  }

  .input-radio-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
  }

  .business-honor-tags {
    .el-tag + .el-tag {
      margin-left: 10px;
    }

    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }

    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
  }
}

.file_flex {
  margin-bottom: 10px;
  width: 600px;
  display: flex;
  justify-content: space-between;
}

/deep/.el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}

/deep/.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}

/deep/ .el-form-item__label {
  box-sizing: border-box;
  padding-right: 10px !important;
}
/deep/ .el-upload--picture-card {
  width: 76px !important;
  height: 76px !important;
  line-height: 76px;
}

.operate-group {
  display: flex;
  align-content: center;
}

.attr-table-box {
  margin-left: 100px;
}

.delete-box {
  margin-left: 15px;
}

.newsLookInfo {
  width: 1000px;
  background-color: white;
  padding: 30px 10px 10px 10px;
  overflow: auto;

  .el-form {
    .el-form-item {
      margin-bottom: 10px;

      /deep/ .el-form-item__label {
        padding: 0;
      }

      .el-textarea {
        width: 80%;
      }

      /deep/ .el-select {
        width: 600px;
      }

      // /deep/ .el-textarea textarea{border: none;}
      /deep/ .el-textarea__inner {
        height: 100%;
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background-color: white;
        color: #606266;
        cursor: default;
        padding: 0;
      }

      /deep/ .el-textarea.is-disabled .el-textarea__inner {
        background-color: white;
        color: #606266;
        cursor: default;
      }
    }
  }

  .bottonMessage {
    p {
      color: #7c7f8e;
      font-size: 14px;
      padding-left: 100px;
    }
  }
}

.bottom {
  border-top: 1px solid #dbdbdb;
  background: #fff;
  padding: 10px 20px;
  display: flex;
  justify-content: center;

  .el-button {
    margin: 0 20px;
  }
}

::-webkit-scrollbar-thumb {
  background-color: grey;
}

/deep/ .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
</style>
